module.exports = "<div class=\"main\">\n  <div *ngFor=\"let ab of about\" class=\"content\">\n      <h1>Tim van Wankum</h1>\n      <h3>{{ab.fields.function}}</h3>\n      <div class=\"about-me\" markdown-to-html [data]=\"ab.fields.long\"></div>\n      <!-- <h2>\n            <markdown-to-html>\n                {{ab.fields.long}}\n            </markdown-to-html>\n      </h2> -->\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/timva/Documents/Work/LatestDownload/src/app/about/about.component.html
// module id = ../../../../../src/app/about/about.component.html
// module chunks = main